/**
 * Tracker status-text parsing shared by the Invoicing and Reconciliation dashboards.
 * The legacy Monthly Invoicing Tracker's Status column is free text ("Paid",
 * "Unpaid", "Sent to agency", …). Negated forms are checked first: "Unpaid" /
 * "Not paid" contain the substring "paid" and must never read as paid (the same
 * negation trap isConfirmed guards against).
 */

export type PaidVariant = 'paid' | 'unpaid' | 'other' | 'none';

/** True when the status text does NOT read as paid (blank counts as unpaid). */
export const isUnpaidStatus = (s: string): boolean => {
  if (/\b(?:not|un)[^a-z0-9]*paid\b/i.test(s)) return true;
  return !/\bpaid\b|complete|closed/i.test(s);
};

/**
 * Display-oriented classification: blank → 'none', explicit not/un-paid → 'unpaid',
 * paid/complete/closed → 'paid', anything else → 'other' (show the raw text).
 */
export const paidVariant = (s?: string): PaidVariant => {
  const t = (s ?? '').trim();
  if (!t) return 'none';
  if (/\b(?:not|un)[^a-z0-9]*paid\b/i.test(t)) return 'unpaid';
  if (/\bpaid\b|complete|closed/i.test(t)) return 'paid';
  return 'other';
};
